import { DetailsRequestProps, GqlBodyProps, GqlQueryAndVariablesBuilder } from 'store/api/api.types';
import { DetailsQueryBuilder } from 'gql/autogen/DetailsQueryBuilder';
import detailsQueryGenerator from 'gql/activityBuilder/details/query/queryGenerator';
import detailsVariableGenerator, { buildLogTags } from 'gql/activityBuilder/details/variables/variablesGenerator';
import { DefaultRequestProps } from 'store/api/ApiConstants';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentId } from 'core/type/ExperimentId';
import { selectPageTypeIdFromBootstrap } from 'store/slice/bootstrap';

const buildQueryAndVariables: GqlQueryAndVariablesBuilder = (state, props, context): GqlBodyProps => {
    const queryGenerator = detailsQueryGenerator();
    const variablesGenerator = detailsVariableGenerator(state, (props as DetailsRequestProps) || DefaultRequestProps.details, context);
    const queryBuilder = new DetailsQueryBuilder(queryGenerator, variablesGenerator);

    const query = queryBuilder.buildQuery();
    const variables = queryBuilder.buildVariables();
    const logTags = buildLogTags(state, variables);
    const queryString = `?operation=${logTags.operation}&activityId=${logTags.activityId}`;
    const pageTypeId = isB(ExperimentId.ACT_4968, state.bootstrap.config.experiments) ? selectPageTypeIdFromBootstrap(state) : state.navigation.pageTypeId;

    return { queryString, variables, query, logTags, pageTypeId };
};

export default buildQueryAndVariables;
